import React from "react";
import blankPhoto from "../../PicesForPages/blank.jpg";
import KishoreKumarVeeragandham from "../../PicesForPages/KishoreKumarVeeragandham.webp";
import LavanyaDonkala from "../../PicesForPages/LavanyaDonkala.webp";
import VideeshVeeragandham from "../../PicesForPages/VideeshVeeragandham.webp";

import { Link } from "react-router-dom";

function YourTeamMembers() {
  const teamMembers = [
    {
      name: "Kishore Kumar Veeragandham",
      role: "Sr. Mortgage Loan Originator - FL, OH & TX",
      photo: KishoreKumarVeeragandham,
      link: "kishorekumar-veeragandham",
      nmls: "2212174",
    },
    {
      name: "Lavanya Donkala",
      role: "Mortgage Loan Originator - OH",
      photo: LavanyaDonkala,
      link: "lavanya-donkala",
      nmls: "2594203",
    },
    {
      name: "Videesh Veeragandham",
      role: "Mortgage Loan Originator - OH",
      photo: VideeshVeeragandham,
      link: "videesh-veeragandham",
      nmls: "2832629",
    },
    {
      name: "Coming Soon",
      role: "---- ---------",
      photo: blankPhoto,
      link: "#",
      nmls: "-------",
    },
  ];

  return (
    <div className="teamBoxParent">
      <div className="teamBox">
        <span className="teamHeading">Meet Our Dedicated Family</span>
        <span className="teamContent">
          At <span className="brand_text">VIDHI MORTGAGE LLC</span> we pride
          ourselves on delivering expert guidance, prompt service, and a
          seamless experience—supporting you at every step with confidence.
        </span>
        <div className="teamListBoxParent">
          {teamMembers.map((member, index) => (
            <Link
              to={member.link !== "#" ? `/our-staff/${member.link}` : "#"}
              className="teamListBox"
              key={index}
            >
              <span className="teamListSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={member.photo}
                  alt={member.name}
                />
              </span>
              <span className="teamListNameOfficer">
                <span className="teamListOfficerRole">{member.role}</span>
                <span className="teamListName">{member.name}</span>
                <hr className="teamListHR" />
                <span className="teamListOfficerNMLSViewProfile">
                  <span className="teamListOfficerNMLS">
                    NMLS#: {member.nmls}
                  </span>
                  <span className="teamListOfficerViewProfile">
                    VIEW PROFILE <i className="ri-arrow-right-circle-line"></i>
                  </span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default YourTeamMembers;
